import React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';

const Modal = ({ 
    children, 
    show = false, 
    onHide, 
    title, 
    size, 
    centered = false, 
    backdrop = true,
    keyboard = true,
    scrollable = false,
    fullscreen,
    footer,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <BootstrapModal 
            show={show} 
            onHide={onHide} 
            size={size}
            centered={centered}
            backdrop={backdrop}
            keyboard={keyboard}
            scrollable={scrollable}
            fullscreen={fullscreen}
            className={className}
            style={style}
            {...props}
        >
            {title && (
                <BootstrapModal.Header closeButton>
                    <BootstrapModal.Title>{title}</BootstrapModal.Title>
                </BootstrapModal.Header>
            )}
            <BootstrapModal.Body>{children}</BootstrapModal.Body>
            {footer && <BootstrapModal.Footer>{footer}</BootstrapModal.Footer>}
        </BootstrapModal>
    );
};

export default Modal;

